// src/app/core/auth/auth-heartbeat.service.ts

import { Injectable, OnDestroy } from "@angular/core";
import { AuthService } from "./auth.service";
import { LoggerService } from "../../shared/services/logger.service";

@Injectable({
  providedIn: "root"
})
export class AuthHeartbeatService implements OnDestroy {

  private hourlyIntervalId: ReturnType<typeof setInterval> | undefined;

  private heartbeatStarted = false;

  constructor(private auth: AuthService, private logger: LoggerService) { }

  start(): void {
    if (this.auth.isExternallyAuthenticated()) {
      this.logger.info("[AuthHeartbeat] External authentication detected. Heartbeat will not start.");
      return;
    }

    if (this.heartbeatStarted) {
      return;
    }
    this.heartbeatStarted = true;

    // 1) Hourly interval (every 60 minutes)
    this.hourlyIntervalId = setInterval(() => {
      this.logger.info("[AuthHeartbeat] Performing hourly silent token refresh.");
      this.auth
        .trySilentRefresh()
        .catch(err => {
          this.logger.error("[AuthHeartbeat] Hourly refresh failed:", err);
        });
    }, 59 * 60 * 1000); // 59min × 60sec × 1000ms

    // 2) Listen for browser “online” event
    window.addEventListener("online", () => {
      this.logger.info("[AuthHeartbeat] Browser came online. Ensuring fresh token via silent refresh.");

      this.auth
        .trySilentRefresh()
        .catch(err => {
          this.logger.error("[AuthHeartbeat] Refresh on 'online' event failed:", err);
        });
    });

    this.logger.info("[AuthHeartbeat] Started");
  }

  ngOnDestroy(): void {
    if (this.hourlyIntervalId) {
      clearInterval(this.hourlyIntervalId);
    }
  }
}
